import { DiscoveryProduct } from '@teko/discovery';
import { isDisplayUomByTenant } from 'helpers';
import { useCallback } from 'react';
import { useTenantConfig, useFrame, useHelper, useCartV2 } from '../contexts';
import { Caption } from '@teko/ds-desktop';
import { ProductCardProps } from '@teko/types/ecommerce';

export const useNewProductCard = () => {
  const { allowAddToCartFromListing, contactLink } = useTenantConfig();
  const { productHelper } = useHelper();
  const { frames } = useFrame();
  const cartV2 = useCartV2();
  const { tenant, uomCodeToDisplayDecimalQuantity } = useTenantConfig();
  const showUom = isDisplayUomByTenant(tenant);
  const convertNewProductCard = useCallback(
    (el: DiscoveryProduct) => {
      const product: ProductCardProps = allowAddToCartFromListing
        ? {
            ...productHelper.convertNewProductCard(el, {
              cartV2,
              frames,
              showUom,
              contactLink,
            }),
            precisionToDisplayDecimalQuantity:
              uomCodeToDisplayDecimalQuantity === el.productInfo.uomCode
                ? 3
                : 0,
          }
        : productHelper.convertNewProductCard(el, {
            frames,
            showUom,
          });

      product.renderUom =
        product.uom && showUom ? (
          <Caption
            level={1}
            color={'textSecondary'}
            style={{ marginTop: '0.25rem' }}
          >
            ĐVT:{' '}
            {uomCodeToDisplayDecimalQuantity !== product.uom.uomCode
              ? `${product.uom.uomRatio < 1 ? 1 : product.uom.uomRatio} `
              : ''}
            {product.uom.uomName}
          </Caption>
        ) : undefined;
      return product;
    },
    [cartV2, frames],
  );
  return { convertNewProductCard };
};
